import styled from "styled-components";
import theme from "../../style/theme";
import CheckedBoxIcon from "../icons/CheckedBoxIcon";
import UncheckedBoxIcon from "../icons/UncheckedBoxIcon";

interface Props {
    checked: boolean;
    text1: string;
    text2: string;
    disabled?: boolean;
    onClick: () => void;
}

export const RoutingServiceCheckBox: React.FC<Props> = (
    {
        checked,
        text1,
        text2,
        disabled,
        onClick,
    }
) => {
    return (
        <EndLocationOption1 onClick={onClick}>
            {checked ? (
                <>
                    <CheckedBoxIcon
                        fill={disabled ? "#979DA8" : "#FCCA00"}
                        width={18}
                        height={18}
                    />
                    <EndLocationOption1Label color={theme.palette.primitives.gray600}>
                        {text1}
                    </EndLocationOption1Label>
                    <EndLocationOption1SubLabel color={theme.palette.primitives.gray600}>
                        {/* - *최적 배차 종료지로 자동 입력 */}
                        {text2}
                    </EndLocationOption1SubLabel>
                </>
            ) : (
                <>
                    <UncheckedBoxIcon
                        fill={
                            disabled
                                ? theme.palette.primitives.gray100
                                : theme.palette.primitives.gray300
                        }
                        width={18}
                        height={18}
                    />
                    <EndLocationOption1Label
                        color={
                            disabled
                                ? theme.palette.primitives.gray200
                                : theme.palette.primitives.gray600
                        }
                    >
                        {text1}
                    </EndLocationOption1Label>
                    <EndLocationOption1SubLabel
                        color={
                            disabled
                                ? theme.palette.primitives.gray200
                                : theme.palette.primitives.gray400
                        }
                    >
                        {/* - *최적 배차 종료지로 자동 입력 */}
                        {text2}
                    </EndLocationOption1SubLabel>
                </>
            )}
        </EndLocationOption1>
    );
};

const EndLocationOption1 = styled.div`
  display: flex;
  width: max-content;
  align-items: center;
  cursor: pointer;
`;

interface EndLocationOption1LabelProps {
    color: string;
}

const EndLocationOption1Label = styled.div<EndLocationOption1LabelProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 0 0 0 8px;
`;

interface EndLocationOption1SubLabelProps {
    color: string;
}

const EndLocationOption1SubLabel = styled.div<EndLocationOption1SubLabelProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 0 0 0 4px;
`;
